<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
    import AppMixin from '@nodes/mixins/App';
    import SettingsMixin from '@nodes/settings/mixins/index';
    // %import%

    export default {
        name: 'App',

        mixins: [
            AppMixin,
            SettingsMixin,
            // %mixins%
        ],

        /**
         * @inheritdoc
         */
        mounted() {
            if (this.$config('store.modules').includes('cart') && this.$store.getters['auth/isLoggedIn'] && this.$route.name !== 'cart') {
                this.refreshList();
            }
        },

        /**
         * @inheritdoc
         */
        created() {
            if (!this.$store.getters['division/division'].country) {
                this.$services.list('city', {
                    title    : 'TEHRAN',
                    including: ['division'],
                }).then((response) => {
                    this.$store.dispatch('division/setDivision', this.get(response.data.results, '0.division'));
                }).catch((error) => {
                    this.handleError(error);
                });
            }
        },

        methods: {
            /**
             * Refresh order list
             * 
             * @returns {Promise}
             */
            refreshList() {
                let myCart = [];
                return this.$services.Cart.myOrderRefresh({ type: 'products', including: ['items'] }).then((response) => {
                    if (this.get(response.data.results, 'items', []).length) {
                        myCart = [{
                            id   : this.get(response.data.results, 'id', ''),
                            items: this.get(response.data.results, 'items', []),
                        }];
                    } else {
                        myCart = [];
                    }

                    this.$store.dispatch('cart/emptyCart');
                    this.$store.dispatch('cart/updateMyCart', this.get(myCart, '0.items', []));
                }).catch((error) => {
                    this.handleError(error);
                });
            },
        },
    };

</script>
